import React from 'react';
import './FilterMenu.css';

interface FilterMenuProps {
    categories: string[];
    activeCategory: string | null;
    onSelectCategory: (category: string | null) => void;
}

const FilterMenu: React.FC<FilterMenuProps> = ({ categories, activeCategory, onSelectCategory }) => {
    return (
        <div className="filter-menu-container">
            <button
                className={`filter-chip ${activeCategory === null ? 'active' : ''}`}
                onClick={() => onSelectCategory(null)}
            >
                TOUS
            </button>
            {categories.map((category) => (
                <button
                    key={category}
                    className={`filter-chip ${activeCategory === category ? 'active' : ''}`}
                    onClick={() => onSelectCategory(category)}
                >
                    {category.toUpperCase()}
                </button>
            ))}
        </div>
    );
};

export default FilterMenu;
